"use strict";

import Vue from 'vue';
import router from './../router'
import store from '@/store'
import axios from "axios";
import qs from 'qs';
import {
  getToken,
  getHdToken
} from '@/utils/auth'
import httpConfig from '@/api/httpConfig'
import {
  Toast,
  Indicator
} from "mint-ui";
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = httpConfig


const _axios = axios.create(config);
const noDeedLoading = ['userInfo', 'list', 'check', 'transactions', 'info','wallet/getBalance','wallet/getTokenBalance']
_axios.interceptors.request.use(
  function (config) {
    config.headers['XX-Token'] = getToken() || ""
    config.headers['XX-Hd-Token'] = getHdToken() || ""
    config.headers['XX-Device-Type'] = window.sys || "web"
    if (config.method == "post" && !(config.data instanceof FormData)) {
		//取消post参数单列化
		// config.data = qs.stringify(config.data, {
		//   indices: false
		// });
    }
    if (checkLoading(config.url)) {
      Indicator.open()
    }

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

function checkLoading(url) {
  let r = true
  noDeedLoading.forEach(function (val, index) {
    if (url.indexOf(val) != -1) {
      r = false
      return
    }
  });
  return r
}
// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    Indicator.close()
    if (response.data.code == 10001) {
      store.dispatch("removeToken");
      router.replace('/relogin');
    }
    var resUrl = response.request.responseURL;
    var baseUrl = response.config.baseURL;
    if ((resUrl.startsWith(baseUrl + "/api") && response.data.code != 1) || (resUrl.startsWith(baseUrl + "/wtcenter") && response.data.code != 0)) {
      Toast(response.data.msg);
      return Promise.reject(response.data.code);
    }
    return response.data;

  },
  function (error) {
    Indicator.close()
    Toast(error);
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function (Vue, options) {
  Vue.axios = _axios;
  Vue.$axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)
export default Plugin;